import produce from 'immer';

import {
  CASE_ROLE_CREATE_FAILURE,
  CASE_ROLE_CREATE_SUCCESS,
  EDIT_CASE_ROLE_FAILURE,
  EDIT_CASE_ROLE_SEQUENCE_FAILURE,
  EDIT_CASE_ROLE_SEQUENCE_SUCCESS,
  EDIT_CASE_ROLE_SUCCESS,
  GET_CASE_ROLE_FAILURE,
  GET_CASE_ROLE_LIST_FAILURE,
  GET_CASE_ROLE_LIST_SUCCESS,
  GET_CASE_ROLE_SUCCESS,
} from '@actions/caseRole';

const initialState: ICaseRoleStore = {
  currentCaseRole: null,
  caseRoles: null,
  error: null,
};

export default (state: ICaseRoleStore = initialState, action: any) =>
  produce(state, (draftState: ICaseRoleStore) => {
    switch (action.type) {
      case EDIT_CASE_ROLE_SUCCESS:
      case CASE_ROLE_CREATE_SUCCESS:
      case GET_CASE_ROLE_SUCCESS:
        draftState.currentCaseRole = action.response;
        draftState.error = null;

        return;

      case EDIT_CASE_ROLE_FAILURE:
      case CASE_ROLE_CREATE_FAILURE:
        draftState.error = action.error;

        return;

      case GET_CASE_ROLE_FAILURE:
        draftState.currentCaseRole = null;
        draftState.error = action.error;

        return;

      case GET_CASE_ROLE_LIST_SUCCESS:
      case EDIT_CASE_ROLE_SEQUENCE_SUCCESS:
        draftState.caseRoles = action.response;
        draftState.error = null;

        return;

      case GET_CASE_ROLE_LIST_FAILURE:
      case EDIT_CASE_ROLE_SEQUENCE_FAILURE:
        draftState.error = action.error;

        return;
    }
  });
